import React from "react";
import CtaLink from "../../../../Elements/CtaLink";
import { CloudinaryImage } from "@website-builder/ui/shared/elements";
import { ItemWrapper } from "./style";

const BlogItem = ({
	header,
	description,
	imageConfig: { imageUrl = "", altTag = "" } = {},
	full_slug,
	publishedDate,
	allowTitleNavigation,
}) => {
	return (
		<ItemWrapper className="blog-items">
			<aside>
				<CloudinaryImage
					url={imageUrl}
					sizes={{
						default: {
							width: 180,
							height: 180,
						},
					}}
					mode={"fill"}
					alt={altTag}
				/>
			</aside>
			<div className="blog-content">
				{!allowTitleNavigation ? (
					<h2>{header}</h2>
				) : (
					<CtaLink
						value={`/${full_slug}`}
						type="external"
						target="_self"
						className="header-as-link"
					>
						{header}
					</CtaLink>
				)}
				<p className="date">{publishedDate}</p>
				<p className="description">{description}</p>
				{!allowTitleNavigation ? (
					<CtaLink
						value={`/${full_slug}`}
						type="external"
						target="_self"
						className="read-more"
					>
						Read More
					</CtaLink>
				) : null}
			</div>
		</ItemWrapper>
	);
};

export default BlogItem;
